<template>
  <div class="authority">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/behoerden">Ämter & Behörden</router-link>
      <router-link to="/behoerden/100">Schulverwaltungsamt</router-link>
    </Breadcrumb>

<!-- Authority -->
    <div class="map">
      <div class="wrapper">
        <div class="row between-xs middle-xs">
          <div class="map__box col-xs-12 col-md-6">
            <Headline subline="Ämter & Behörden" headline="Schulverwaltungsamt Augsburg" />
            <p>Das Augsburger Schulverwaltungsamt ist nicht nur für die Verteilung der Lehrkräfte an Augsburgs Schulen und deren Aufsicht zuständig, sondern bearbeitet und verwaltet auch Anträge auf Ausbildungsförderung <b>(BAföG)</b>.</p>
            <h6 class="margin-top--30 margin-bottom--10">Adresse:</h6>
            <p>Gögginger Straße 59 <br>96159 Augsburg</p>
          </div>
          <div class="map__pin col-xs-12 col-md-4 hide-mobile" @click="toggleModal">
            <div class="map__pin__point">
            </div>
            <div class="map__pin__adress">
              <p>Schulverwaltungsamt Augsburg</p>
              <p>Gögginger Straße 59, 86159 Augsburg</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-description margin-top--30 hide-mobile">
      <div class="wrapper flex">
        <Icon icon="route" />
        <p>Auf Karte klicken um Anfahrt zu berechnen</p>
      </div>
    </div>
    <Modal v-if="showModal" @closeModal="toggleModal" :outside="true">
      <Card padding="35px" class="modal-new">
        <Headline subline="Anfahrt berechnen" headline="Leider nicht möglich"/>
        <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
      </Card>           
    </Modal>

<!-- Content -->
    <div class="wrapper main margin-top--90">
      <div class="row between-xs top-xs">
        <div class="sidebar col-xs-12 col-md-4">
          <h3 class="margin-bottom--20">Auf dieser Seite</h3>
          <div class="greenline margin-bottom--30"></div>
          <a href="#" class="link margin-bottom--10"><Icon icon="arrowRight" color="green"/>Ausbildungsförderung (BAföG) für Studenten</a>
          <a href="#" class="link margin-bottom--10"><Icon icon="arrowRight" color="green"/>Ausbildungsförderung (BAföG) für Schüler</a>
          <a href="#" class="link margin-bottom--10"><Icon icon="arrowRight" color="green"/>Aufstiegs-BAföG (Aufstiegsfortbildung)</a>
          <a href="#services" class="link margin-bottom--10"><Icon icon="arrowRight" color="green"/>Zugeordnete Leistungen</a>
          <a href="#spc" class="link margin-bottom--10"><Icon icon="arrowRight" color="green"/>Kontakt</a>
        </div>

        <div class="content col-xs-12 col-md-7">
          <div class="service-teaser">
            <div class="service-teaser__header">
              <div class="icon"><Icon icon="university" color="detailed" /></div>
              <h3>Ausbildungsförderung (BAföG) für Studenten</h3>
            </div>
            <div class="service-teaser__content">
              <p>Ihre Hochschulausbildung wird individuell finanziell gefördert, soweit die für den Lebensunterhalt und die Ausbildung erforderlichen Mittel nicht anderweitig zur Verfügung stehen.</p>
              <div class="service-teaser__content__bottom">
                <div class="with-icon">
                  <Icon icon="computer"/><p>Online Service vorhanden</p>
                </div>
                <router-link to="/behoerden/100/sub" class="link"><Icon icon="arrowRight" color="green"/>Mehr erfahren</router-link>
              </div>
            </div>
          </div>
          <div class="service-teaser">
            <div class="service-teaser__header">
              <div class="icon"><Icon icon="university" color="detailed" /></div>
              <h3>Ausbildungsförderung (BAföG) für Schüler</h3>
            </div>
            <div class="service-teaser__content">
              <p>Ihre Hochschulausbildung wird individuell finanziell gefördert, soweit die für den Lebensunterhalt und die Ausbildung erforderlichen Mittel nicht anderweitig zur Verfügung stehen.</p>
              <div class="service-teaser__content__bottom">
                <div class="with-icon">
                  <Icon icon="computer"/><p>Online Service vorhanden</p>
                </div>
                <router-link to="/behoerden/100/sub" class="link"><Icon icon="arrowRight" color="green"/>Mehr erfahren</router-link>
              </div>
            </div>
          </div>
          <div class="service-teaser">
            <div class="service-teaser__header">
              <div class="icon"><Icon icon="university" color="detailed" /></div>
              <h3>Aufstiegs-BAföG (Aufstiegsförderung)</h3>
            </div>
            <div class="service-teaser__content">
              <p>Ihre Hochschulausbildung wird individuell finanziell gefördert, soweit die für den Lebensunterhalt und die Ausbildung erforderlichen Mittel nicht anderweitig zur Verfügung stehen.</p>
              <div class="service-teaser__content__bottom">
                <div class="with-icon">
                  <Icon icon="computer"/><p>Online Service vorhanden</p>
                </div>
                <router-link to="/behoerden/100/sub" class="link"><Icon icon="arrowRight" color="green"/>Mehr erfahren</router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

<!-- Services -->
    <div class="wrapper margin-bottom--90 margin-top--90" id="services">
      <div class="headline-link">
        <Headline subline="Bürgerservice" headline="Zugeordnete Leistungen" />
        <div class="list-layout">
          <Icon icon="list"/>
          <Icon icon="grid" class="list-layout--active"/>
        </div>
      </div>
      <SearchFilter :action="filterList" v-model="searchTerm" placeholder="Nach Dienstleistung suchen..."></SearchFilter>
      <Alphabet class="margin-top--20"/>
      <p v-if="allServices.length < 1" class="no-results">
        <span>Keine Ergebnisse</span>
        Leider konnten keine passenden Services unter dieser Behörde gefunden werden. 
        <br>Eventuell finden Sie in unserem <router-link to="/lebensbereiche">Lebensbereiche-Abschnitt</router-link> nach dem passenden Service für Ihr Anliegen.
      </p>
      <paginate v-else
            ref="paginator"
            name="allServices"
            :list="allServices"
            :per="12"
            class="margin-top--40"
          >
        <transition-group name="list" class="row">
          <div v-for="service in paginated('allServices')" :key="service.id" class="list-item col-xs-12 col-sm-6 col-md-3">
            <ServiceCard :service="service"/>
          </div>
        </transition-group>
      </paginate>
      <router-link to="/services" class="link margin-top--20"><Icon icon="arrowRight" color="green"/>Zu allen Dienstleistungen</router-link>
    </div>

<!-- SPC -->
    <div class="wrapper spc" id="spc">
      <Headline class="margin-bottom--40" subline="Kontakt" headline="Kontakt & Öffnungszeiten" />
    </div>
    <div class="teaser">
      <div class="wrapper">
        <div class="row">
          <div class="spc__data col-xs-12 col-sm-4">
            <h6>Adresse</h6>
            <p>Gögginger Straße 59</p>
            <p>86159 Augsburg</p>
            <h6>Kontakt</h6>
            <table>
              <tr>
                <td>Telefon:</td>
                <td><a href="tel:+49 821 598-6911">+49 821 598-6911</a></td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td><a href="mailto:sva@augsburg.services">sva@augsburg.services</a></td>
              </tr>
              <tr>
                <td>Leitung:</td>
                <td>Wolfgang Färber</td>
              </tr>
            </table>
          </div>
          <div class="spc__data col-xs-12 col-sm-4">
            <h6>Öffnungszeiten</h6>
            <table>
              <tr>
                <td>Mo, Mi::</td>
                <td>07:30 - 12:30 Uhr, 14:00 - 16:30 Uhr</td>
              </tr>
              <tr>
                <td>Di, Do:</td>
                <td>07:30 - 12:30 Uhr, 14:00 - 17:30 Uhr</td>
              </tr>
              <tr>
                <td>Fr:</td>
                <td>Nur nach Terminvereinbarung</td>
              </tr>
            </table>
          </div>
          <div class="spc__img col-xs-12 col-sm-4 hide-mobile">
            <img src="../../assets/images/spc.png" alt="Ansprechpartner">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import SearchFilter from '../../components/SearchFilter/SearchFilter';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import Alphabet from '../../components/Alphabet/Alphabet';
import Modal from '../../components/Modal/Modal';
import Card from '../../components/Card/Card';

export default {
  name: 'Authority',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    SearchFilter,
    ServiceCard,
    Alphabet,
    Modal,
    Card,
  },
  data() {
    return {
      searchTerm: '',
      allServices: null,
      showModal: false,
      paginate: [ 'allServices' ],
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      getAllServices: 'services/getAllServices',
      getServicesByTitle: 'services/getServicesByTitle',
    }),
  },
  methods: {
    filterList() {
      this.allServices = this.getServicesByTitle(this.searchTerm);
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
  },
  created() {
    this.allServices = this.getAllServices;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Authority.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Authority/Authority.vue